import { Calendar, MapPin, Users } from 'lucide-react';

/**
 * Hero + capacity + age-gate strip shown at the top of the public RSVP page.
 *
 * Props:
 *   info      — the /rsvp/{code} response (event_image, event_title, event_venue,
 *               code, at_capacity, wait_list_mode, spots_left)
 *   minAge    — resolved event min age (defaults to 21)
 *   eventWhen — pre-formatted "YYYY-MM-DD · HH:MM" string
 */
export default function RsvpEventHeader({ info, minAge, eventWhen }) {
  return (
    <div className="border border-zinc-800 bg-[#0A0A0A] overflow-hidden mb-8">
      {info.event_image && (
        <div className="h-48 relative overflow-hidden">
          <img
            src={info.event_image}
            alt=""
            className="w-full h-full object-cover img-grayscale"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] to-transparent" />
        </div>
      )}
      <div className="p-6">
        <span className="font-mono text-xs tracking-widest text-[#B5FF00] mb-2 block">
          GUEST LIST · {info.code}
        </span>
        <h1
          className="font-['Josefin_Sans'] text-3xl md:text-4xl text-white mb-2"
          data-testid="rsvp-event-title"
        >
          {info.event_title}
        </h1>
        <p className="text-zinc-400 font-mono text-sm mb-1 flex items-center gap-2">
          <MapPin size={14} /> {info.event_venue}
        </p>
        <p className="text-zinc-400 font-mono text-sm flex items-center gap-2">
          <Calendar size={14} /> {eventWhen}
        </p>
        <div className="mt-4 flex flex-wrap items-center gap-3">
          <div className="inline-flex items-center gap-2 border border-zinc-800 px-3 py-2">
            <Users size={14} className="text-[#B5FF00]" />
            <span className="font-mono text-xs text-white tracking-wider">
              {info.at_capacity ? (
                info.wait_list_mode ? 'LIST FULL · WAIT LIST OPEN' : 'LIST FULL'
              ) : info.spots_left != null ? (
                <>
                  <span className="text-[#B5FF00] font-bold">{info.spots_left}</span> SPOTS LEFT
                </>
              ) : (
                'OPEN GUEST LIST'
              )}
            </span>
          </div>
          <div className="inline-flex items-center gap-2 border border-[#B5FF00]/40 bg-[#B5FF00]/5 px-3 py-2">
            <span
              className="font-mono text-xs text-[#B5FF00] font-bold tracking-wider"
              data-testid="rsvp-min-age"
            >
              {minAge}+ EVENT
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
